import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { teamApi, type Team, type TeamMember } from '../../api/teams';

export function TeamDetailPage() {
  const { id = '' } = useParams();
  const [team, setTeam] = useState<Team | null>(null);
  const [members, setMembers] = useState<TeamMember[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    Promise.all([teamApi.get(id), teamApi.listMembers(id)])
      .then(([t, m]) => { setTeam(t); setMembers(m); })
      .catch((err) => setError(err instanceof Error ? err.message : 'Failed to load team'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <p className="p-6 text-slate-600">Loading team…</p>;
  if (error || !team) return <p className="p-6 text-red-600">{error || 'Team not found'}</p>;

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/teams" className="text-sm text-slate-600 hover:underline">← Teams</Link>
      <h1 className="mt-4 text-2xl font-semibold">{team.name}</h1>
      <p className="text-sm text-slate-500">{team.slug}</p>
      {team.description && <p className="mt-2 text-slate-600">{team.description}</p>}
      <Link to={`/teams/${id}/dashboard`} className="mt-4 inline-block text-sm text-slate-700 hover:underline">View dashboard</Link>
      <section className="mt-8">
        <h2 className="font-medium">Members ({members.length})</h2>
        <ul className="mt-3 space-y-2">
          {members.map((m) => (
            <li key={m.id} className="rounded-lg border bg-white px-4 py-2 text-sm">
              {m.user_id} · {m.role} · {m.status}
            </li>
          ))}
          {members.length === 0 && <p className="text-slate-500">No members yet.</p>}
        </ul>
      </section>
    </div>
  );
}
